import React  from "react"; 
import "./s3.css" 
import { getEnvUrl,getToken } from "../../../utils/Api";
function FileActions({fileKey}) {  
    const DownloadFile=()=>{
        window.location.href=`${getEnvUrl()}/admin/acl/fileDownLoad?key=${fileKey}` 
    }
    return(<>
     <div className="dropdown">
                            <i 
                             onClick={(event) => event.stopPropagation()} // Prevent event bubbling
                            className="bi bi-three-dots" data-bs-toggle="dropdown"  style={{cursor:"pointer"}} ></i>
                            <ul className="dropdown-menu">
                                <li onClick={DownloadFile}  className="cursor-pointer dropdown-item">Download</li>
                            </ul>
                        </div>
    </>)
}
export default FileActions